!function(root, factory){

    factory(root, root.app);

}(this, function(root, app){

	var youtubeIdRegExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;

    function Util(){

        this.shuffleArray = function shuffle(array) {
			var currentIndex = array.length, temporaryValue, randomIndex ;

			// While there remain elements to shuffle...
			while (0 !== currentIndex) {

				// Pick a remaining element...
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex -= 1;

				// And swap it with the current element.
				temporaryValue = array[currentIndex];
				array[currentIndex] = array[randomIndex];
				array[randomIndex] = temporaryValue;
			}

			return array;
		};

		this.removeWhitespace = function(string) {
			return string.replace(/\s/g, "");
		};

		/*
			http://underscorejs.org/#now

			Returns an integer timestamp for the current time, using the fastest method
			available in the runtime. Useful for implementing timing/animation functions.
		*/
		this.now = Date.now || function() {
			return new Date().getTime();
		};

		/**
		 * Returns a function that can only be invoked once, regardless of how many
		 * times it's actually called.
		 *
		 * @param  Function func - The function to be invoked once
		 */
		this.once = function(func) {
			var result;
			return function() {
				if (func) {
					result = func.apply(this, arguments);
					func = null;
				}
				return result;
			};
		};

		/**
		 * http://underscorejs.org/#debounce
		 * Returns a function, that, as long as it continues to be invoked,
		 * will not be triggered. The function will be called after it stops
		 * being called for N milliseconds. If immediate is passed, trigger
		 * the function on the leading edge, instead of the trailing.
		 *
		 * @param  Function func - Function to be debounced
		 * @param  int wait - How long to wait between successive calls to func
		 * @param  boolean immediate - Whether to call func on leading edge (rather
		 *   than trailing edge)
		 */

		this.debounce = function(func, wait, immediate) {
			var timeout, args, context, timestamp, result;

			var later = function() {
				var last = app.util.now() - timestamp;

				if (last < wait && last >= 0) {
					timeout = setTimeout(later, wait - last);
				} else {
					timeout = null;
					if (!immediate) {
						result = func.apply(context, args);
						if (!timeout) context = args = null;
					}
				}
			};

			return function() {
				context = this;
				args = arguments;
				timestamp = app.util.now();
				var callNow = immediate && !timeout;
				if (!timeout) timeout = setTimeout(later, wait);
				if (callNow) {
					result = func.apply(context, args);
					context = args = null;
				}

				return result;
			};
		};

		/*
			Applies video poster to video wrap element as a fallback for IE8 HTML5 videos.

			Parameters
			- $videoWraps: jQuery object representing selected <video-wrap-element>'s

			Expects the following DOM hierarchy:
				<video-wrap-element>
					<video poster="NOT UNDEFINED">
		*/
		this.VideoPoster = function($videoWraps) {
			for (var i = $videoWraps.length - 1; i >= 0; i--) {
				var $videoWrap = $($videoWraps[i]);
				var $video = $videoWrap.find("video");
				var posterSrc = $video.attr("poster");
				$videoWrap.css("background-image", "url(" + posterSrc + ")");
			};
		};

		/**
		 * Retrieves the YouTube video identifier from a YouTube URL.
		 *
		 * http://stackoverflow.com/a/3452617
		 */
		this.getYouTubeIdFromUrl = function getYouTubeIdFromUrl(url) {
			var match = url.match(youtubeIdRegExp);
			if (match && match[2].length == 11) {
				return match[2];
			}
        };

        /**
         * Sort jQuery elements with provided comparator function
         */
        this.$sortElements = function $sortElements($elements, comparator) {
            const fragment = document.createDocumentFragment();
            const parent = $elements[0].parentNode;
            $elements.sort(comparator);
            for (var i = 0; i < $elements.length; i++) {
                fragment.appendChild($elements[i]);
            }
            parent.appendChild(fragment);
        };

        this.getNormalizedWindowScrollTop = function getNormalizedWindowScrollTop($window) {
            //cap at 0 min so not to be weird on iphone scrolling up from top
            return Math.max($window.scrollTop(), 0);
        };

        /**
         * Toggles browser fullscreen
         *
         * https://stackoverflow.com/a/36672683
         */
        this.fullscreen = function fullscreen() {
            var isInFullScreen = (document.fullscreenElement && document.fullscreenElement !== null) ||
                (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
                (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
                (document.msFullscreenElement && document.msFullscreenElement !== null);

            var docElm = document.documentElement;
            if (!isInFullScreen) {
                if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen();
                } else if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen();
                } else if (docElm.msRequestFullscreen) {
                    docElm.msRequestFullscreen();
                } else if (docElm.requestFullscreen) {
                    docElm.requestFullscreen();
                }
            } else {
                fullscreenExit();
            }
        }

        /**
         * Exits browser fullscreen, preferring vendor-prefixed functions
         * first. In at least Firefox, the generic exitFullscreen function
         * is a no-op.
         *
         * https://stackoverflow.com/a/36672683
         */
        this.fullscreenExit = function fullscreenExit() {
            if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
        
    };

    app.extend({ util: new Util() });

    return app.util;

});
